import { render, staticRenderFns } from "./RankingBoard.vue?vue&type=template&id=471287b4&scoped=true"
import script from "./RankingBoard.vue?vue&type=script&lang=js"
export * from "./RankingBoard.vue?vue&type=script&lang=js"
import style0 from "./RankingBoard.vue?vue&type=style&index=0&id=471287b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471287b4",
  null
  
)

export default component.exports